var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex flex-col w-full mx-auto relative px-4 md:px-0 md:w-main top-mainlow md:top-main"},[_c('MainStory'),_c('MainFaq'),_c('MainPartner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }